module.exports = __webpack_public_path__ + "img/berni.5be4c58d.jpg";